import { axiosInstance } from '../../../common/api';

export const login = (data) => ({ type: 'LOGIN', payload: axiosInstance.post('auth/login', data) });
 